export default __webpack_public_path__ + "static/media/lock-outline.b521d460.svg";